import { LocationStrategy } from '@angular/common';
import {
  Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges,
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterLinkWithHref } from '@angular/router';
import { CarmRouter } from '@carm/_core/carm-router/services/carm-router.service';


@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[carmRouterLink]',
})

// @ts-ignore
export class CarmRouterLinkDirective extends RouterLinkWithHref implements OnChanges {

  private renderer: Renderer2;
  private elementRef: ElementRef;

  constructor(private carmRouter: CarmRouter, router: Router, activatedRoute: ActivatedRoute, renderer2: Renderer2, elementRef: ElementRef, locationStrategy: LocationStrategy) {
    super(router, activatedRoute, null, renderer2, elementRef, locationStrategy);

    this.renderer = renderer2;
    this.elementRef = elementRef;

    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.rebuildLink();
      }
    });
  }

  @Input('carmRouterLink') segments: string | string[];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.segments.currentValue) {
      this.rebuildLink();
    }
  }

  private rebuildLink(): void {
    if (!Array.isArray(this.segments)) {
      if (this.segments) {
        this.segments = !this.segments.includes("https") ? [...this.segments.split('/')] : [this.segments];
      } else {
        this.segments = [];
      }
    }

    this.routerLink = this.carmRouter.buildSegments(this.segments);
    this.href = !this.segments[0].includes("https") ? this.carmRouter.buildHref(this.segments) : this.segments[0];
    this.renderer.setAttribute(this.elementRef.nativeElement, 'href', this.href);

  }
}
